var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4068 21.546C11.1683 21.546 8.54297 18.9208 8.54297 15.6822C8.54297 12.4437 11.1683 9.81842 14.4068 9.81842C17.6454 9.81842 20.2706 12.4437 20.2706 15.6822C20.2706 18.9208 17.6454 21.546 14.4068 21.546Z",
    stroke: "white",
    strokeWidth: 3.90921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67969 37.1829V35.2283C2.67969 30.9104 6.18011 27.4099 10.4981 27.4099H18.3165C22.6344 27.4099 26.1349 30.9104 26.1349 35.2283V37.1829",
    stroke: "white",
    strokeWidth: 3.90921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9961 2V13.7276",
    stroke: "white",
    strokeWidth: 3.90921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1367 7.8638H37.8643",
    stroke: "white",
    strokeWidth: 3.90921,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMember);
export default __webpack_public_path__ + "static/media/newMember.f3188ef646f199b34248b6d8648306e0.svg";
export { ForwardRef as ReactComponent };